import VerticalFlex from "layouts/flex/VerticalFlex";
import style from "./LatestArticles.module.css";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import CustomIcon from "components/icons/CustomIcon";
import P from "components/P";
import Inline from "layouts/container/Inline";
import Center from "layouts/wrapper/Center";
import { useEffect, useState } from "react";
import { adminRequester } from "App";
import { t } from "i18next";
import NiceModal from "@ebay/nice-modal-react";
import { isDefaultBoardName } from "modals/article/BoardDetailModal";

function LatestArticles() {
  const [mounted, setMounted] = useState(false);
  const [data, setData] = useState([]);
  useEffect(() => {
    setMounted(true);
  }, []);
  useEffect(() => {
    if (mounted) {
      adminRequester.getArticleStatus({ status: "list", limit: 5 }, (result) =>
        setData(result.data)
      );
    }
  }, [mounted]);
  const openEdit = ({ row }) => {
    NiceModal.show("articleDetail", {
      data: row,
      editable: false,
    });
  };
  return (
    <div className={style.container}>
      <VerticalFlex>
        <FlexChild>
          <div className={style.label}>
            <HorizontalFlex gap={10}>
              <FlexChild width={"max-content"}>
                <CustomIcon name={"articleOperStatus"} width={20} />
              </FlexChild>
              <FlexChild>
                <P>게시판 최신글</P>
              </FlexChild>
            </HorizontalFlex>
          </div>
        </FlexChild>
        <FlexChild>
          <VerticalFlex>
            {data &&
              data.map((row, index) => (
                <FlexChild>
                  <div
                    className={index % 2 === 0 ? style.evenRow : style.oddRow}
                  >
                    <Center width={"100%"} textAlign={"left"}>
                      <Inline>
                        <P color={"#5471e6"}>
                          [
                          {isDefaultBoardName(row?.board?.name)
                            ? t(row.board.name)
                            : row?.board?.name}
                          ]{" "}
                        </P>
                        <P hover cursor onClick={() => openEdit({ row: row })}>
                          {row.title}
                        </P>
                      </Inline>
                    </Center>
                  </div>
                </FlexChild>
              ))}
          </VerticalFlex>
        </FlexChild>
      </VerticalFlex>
    </div>
  );
}

export default LatestArticles;
